import styled from '@emotion/styled';
import { Box, Flex } from 'components';
import LanguageSwitch from 'components/LanguageSwitch';
import UserBanner from '../components/UserBanner/UserBanner';
import { FLOATING_PROFILE_POSITION_ID } from './Lobby/Profile/FloatingProfilePosition';

const Header = () => {
  return (
    <HeaderWrapper>
      <HeaderProfilePosition id={FLOATING_PROFILE_POSITION_ID} pt={10} />
      <HeaderContainer>
        <Flex>
          <LanguageSwitch />
          <UserBanner />
        </Flex>
      </HeaderContainer>
    </HeaderWrapper>
  );
};

export default Header;

const HeaderWrapper = styled('div')({
  position: 'absolute',
  right: 0,
  top: 0,
  zIndex: 10000,
  pointerEvents: 'none',
});

const HeaderContainer = styled('header')({
  zIndex: 10001,
});

const HeaderProfilePosition = styled(Box)`
  position: absolute;
  right: 1.5em;
  top: 2.5em;
`;
